import { Component, effect, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

import { ProfileService } from '../../profile/profile.service';

@Component({
  selector: 'project-no-access',
  imports: [FwLayoutContextComponent, FwButtonComponent, RouterLink],
  template: `
    <header class="content-header"></header>
    <fw-layout-context
      description="Your sign-in was successful but you don't have permission to access this resource."
      icon="lock"
      title="You don't have access to this project"
    >
      <fw-button leftIcon="folder-open" routerLink="/projects" variant="outline"> Projects </fw-button>
      @if (isSiteAdmin()) {
        <fw-button color="secondary" leftIcon="crown-style-circle" variant="outline" (click)="enableExhaustiveMode()">
          Manage Site Mode
        </fw-button>
      }
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100%;
        background: var(--page-light);
        display: flex;
        flex-direction: column;

        header {
          margin: 0;
        }

        fw-layout-context {
          flex-grow: 1;
          width: 100%;
        }
      }
    `,
  ],
})
export class ProjectNoAccessComponent {
  private profileService = inject(ProfileService);
  private activeRoute = inject(ActivatedRoute);
  private router = inject(Router);

  protected isSiteAdmin = this.profileService.siteAdmin;

  /**
   * Site mode can be switched on from the button below or from the profile menu in the top bar.
   * Either way it grants a site admin access, so send them on to the project they were denied.
   */
  private loadProjectInSiteMode = effect(() => {
    if (this.profileService.exhaustiveMode()) {
      this.router.navigate(['projects', this.activeRoute.snapshot.params.projectId]);
    }
  });

  protected enableExhaustiveMode(): void {
    this.profileService.showAllData = true;
  }
}
